// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"123":"65ea55e0","8229":"9da6db1e"}[chunkId] || chunkId) + "." + {"123":"7074a0975f4db1a7","5871":"eb90c77e74f062c7","7868":"fb5774f6fdb191e7","8229":"ceb47e9d0a56f3ce","9440":"e6b6ec4219f23bab"}[chunkId] + ".js";
};